<div class="app-grid-fluid mb-2 md:mt-3 md:mb-3">
  <div class="grid grid-nogutter">
    <div class="col-12 justify-content-center margin-below-top-sidebar screen-sticky-control search-results-tabs">
      <p-tabView [scrollable]="true" (onChange)="selectChange()" [(activeIndex)]="selectedIndex">
        <p-tabPanel *ngFor="let tab of tabs" [header]="tab.label|translate">
<!--          <ng-template pTemplate="content">-->
<!--          </ng-template>-->
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
  <div class="grid grid-nogutter flex justify-content-center width-100">
    <div class="col-12 p-0 px-1 pt-2 pb-0 search-results-meta-wrap" style="max-width: 900px">
      <div class="search-results-meta">
        <small class="text-color-secondary" *ngIf="activeResultsCount > 0">
          {{ 'common.search_results_count' | translate:{count: activeResultsCount} | translateSelector: activeResultsCount }}
        </small>
      </div>
    </div>
  </div>

  <div class="grid grid-nogutter flex justify-content-center width-100 margin-over-bottom-sidebar">
    <div class="col-12 p-0 my-2" style="max-width: 900px">
      <swiper
        #slaveSwiper
        [config]="childConfig"
        (activeIndexChange)="setActiveSlide($event)"
        [updateOnImagesReady]="true"
        [updateOnWindowResize]="true"
        [observeSlideChildren]="true"
        [lazy]="true"
        [preloadImages]="true"
        [autoHeight]="true"
        [watchOverflow]="true"
        (slideChange)="selectChange()"
      >
        <ng-template swiperSlide *ngFor="let tab of tabs; let last = last; let i = index">
          <div class="min-h-screen">
            <app-search-infinite-list *ngIf="selectedTab.type === tab.type"
                                      [selectedTab]="selectedTab"
                                      [searchTypes]="searchTypes"
                                      [exactTag]="exactTag"
                                      [noResultsMsg]="'common.no_results'|translate"
            ></app-search-infinite-list>
          </div>

        </ng-template>
      </swiper>
    </div>
  </div>
</div>
